import Client from './client';

export default class ExperimentResultsWithTimestamps extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getCumulative(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiment/${key}/results/cumulative`, options);
  }

}
